<template lang="pug">
div
  SubHeader(apiname='overview',headname='SWAN Proとは')
  .card
    .container-fluid
      h3.box-title SWAN Proとは一覧
      WorkList(apiname='overview',editPath='edit')
      router-link(to='edit')
        el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
import WorkList from '@/views/components/swan/common/List'
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    SubHeader,
    WorkList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/overview/list.vue